module.exports = __webpack_public_path__ + "img/1001.de22a532.jpg";